import { useState, useEffect } from 'react';
import Hero from './components/Hero';
import About from './components/About';
import VPNService from './components/VPNService';
import Features from './components/Features';
import Contact from './components/Contact';
import PrivacyPolicy from './components/PrivacyPolicy';
import Footer from './components/Footer';
import Navbar from './components/Navbar';

export default function Home() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navbar scrolled={scrolled} />
      <Hero />
      <About />
      <VPNService />
      <Features />
      <Contact />
      <PrivacyPolicy />
      <Footer />
    </div>
  );
}
